import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { FeatureState, Feature } from '../../models';
import { FeatureActions, FeatureActionTypes } from '../actions/feature.actions';

export const adapter: EntityAdapter<Feature> = createEntityAdapter<Feature>();
export const initialFeatureState: FeatureState = adapter.getInitialState({});

export const featureReducer = (
  state: FeatureState = initialFeatureState,
  action: FeatureActions,
): FeatureState => {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const cloneObject = (object: any) => JSON.parse(JSON.stringify(object));
  const filterFeatureId = (id: number, featureState: FeatureState) =>
    cloneObject(featureState.selectedFeaturesIds.filter((featureId) => featureId !== String(id)));
  const filterRvoId = (id: string, featureState: FeatureState) =>
    featureState.selectedRvoIds.filter((rvoId) => rvoId !== id);
  const filterRvoFeature = (id: string, featureState: FeatureState) =>
    featureState.selectedRvoFeatures.filter((feature) => feature.id !== id);

  switch (action.type) {
    case FeatureActionTypes.UpsertFeatures: {
      return adapter.upsertMany(action.features, {
        ...adapter.removeAll(state),
        selectedFeaturesIds: [],
      });
    }

    case FeatureActionTypes.UpsertFeature: {
      return adapter.upsertOne(action.feature, state);
    }

    case FeatureActionTypes.DeleteFeature: {
      return adapter.removeOne(action.id, {
        ...state,
        selectedFeaturesIds: filterFeatureId(action.id, state),
      });
    }

    case FeatureActionTypes.SetLastYearsFeatures: {
      return {
        ...state,
        lastYearsFeatures: action.features,
      };
    }

    case FeatureActionTypes.InteractionFeatureModifying: {
      return {
        ...state,
        modifyingFeature: action.feature,
      };
    }

    case FeatureActionTypes.InteractionFeatureSelected: {
      return {
        ...state,
        selectedFeaturesIds: [...state.selectedFeaturesIds, action.id.toString()]
          .sort()
          .filter((s, p, a) => !p || s !== a[p - 1]),
      };
    }

    case FeatureActionTypes.InteractionFeatureDeselected: {
      return {
        ...state,
        selectedFeaturesIds: filterFeatureId(action.id, state),
      };
    }

    case FeatureActionTypes.DeselectInteractionFeatures: {
      return {
        ...state,
        selectedFeaturesIds: [],
      };
    }

    case FeatureActionTypes.InteractionRvoSelected: {
      return {
        ...state,
        selectedRvoIds: [
          action.feature.id,
          // First disable multiselect ...state.selectedFeaturesIds
        ],
        selectedRvoFeatures: [action.feature],
      };
    }

    case FeatureActionTypes.InteractionRvoDeselected: {
      return {
        ...state,
        selectedRvoIds: filterRvoId(action.id, state),
        selectedRvoFeatures: filterRvoFeature(action.id, state),
      };
    }

    case FeatureActionTypes.InteractionLastYearsFeatureSelected: {
      return {
        ...state,
        selectedLastYearsFeatures: [action.feature],
      };
    }

    case FeatureActionTypes.InteractionShapefileFieldSelected: {
      return {
        ...state,
        selectedShapefileFieldFeatures: [action.feature],
      };
    }

    case FeatureActionTypes.DeselectCropFields: {
      return {
        ...state,
        selectedFeaturesIds: [],
      };
    }

    case FeatureActionTypes.DeselectRvoFields: {
      return {
        ...state,
        selectedRvoIds: [],
        selectedRvoFeatures: [],
      };
    }

    case FeatureActionTypes.DeselectAllFields: {
      return {
        ...state,
        selectedFeaturesIds: [],
        selectedRvoIds: [],
        selectedRvoFeatures: [],
        selectedLastYearsFeatures: [],
      };
    }

    default: {
      return state;
    }
  }
};
